import React, { useEffect, useState } from 'react';
import './TermsConditions.css';

const TermsConditions = () => {
  const [isVisible, setIsVisible] = useState(false);
  const today = new Date();
  const lastUpdated = today.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`terms-conditions-container ${isVisible ? 'visible' : ''}`}>
      <div className="terms-conditions-content">
        <header className="terms-header">
          <div className="header-decoration"></div>
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: {lastUpdated}</p>
          <p className="disclaimer">
            Welcome to Emerald Appraisal ("we," "our," or "us"). By accessing or using our website at 
        Emerald Appraisal (the "Site"), you agree to be bound by these Terms of Service. Please read them carefully.
          </p>
        </header>

        <div className="terms-content">
          {/* 1. Use of the Site */}
          <section className="terms-section">
            <div className="section-header">
              <div className="section-number">1</div>
              <h2>Use of the Site</h2>
            </div>
            <div className="section-content">
              <p>
                You may use this Site for lawful purposes only. You agree not to misuse the Site, 
                attempt to gain unauthorized access, or interfere with its normal operation.
              </p>
            </div>
          </section>

          {/* 2. Intellectual Property */}
          <section className="terms-section">
            <div className="section-header">
              <div className="section-number">2</div>
              <h2>Intellectual Property</h2>
            </div>
            <div className="section-content">
              <p>
                All content on this Site (including text, images, graphics, and logos) is owned by 
                or licensed to us and is protected by copyright, trademark, and other intellectual 
                property laws. You may not copy, distribute, or modify our content without written permission.
              </p>
            </div>
          </section>

          {/* 3. No Warranties */}
          <section className="terms-section">
            <div className="section-header">
              <div className="section-number">3</div>
              <h2>No Warranties</h2>
            </div>
            <div className="section-content">
              <p>
                The Site is provided "as is" without warranties of any kind, express or implied. 
                We do not guarantee that the Site will be available at all times, error-free, or secure.
              </p>
            </div>
          </section>

          {/* 4. Limitation of Liability */}
          <section className="terms-section">
            <div className="section-header">
              <div className="section-number">4</div>
              <h2>Limitation of Liability</h2>
            </div>
            <div className="section-content">
              <p>
                To the fullest extent permitted by law, we are not liable for any damages arising 
                from your use of the Site, including indirect or consequential damages.
              </p>
            </div>
          </section>

          {/* 5. Third-Party Links */}
          <section className="terms-section">
            <div className="section-header">
              <div className="section-number">5</div>
              <h2>Third-Party Links</h2>
            </div>
            <div className="section-content">
              <p>
                The Site may contain links to third-party websites. We are not responsible for 
                the content or practices of those sites.
              </p>
            </div>
          </section>

          {/* 6. Changes to Terms */}
          <section className="terms-section">
            <div className="section-header">
              <div className="section-number">6</div>
              <h2>Changes to Terms</h2>
            </div>
            <div className="section-content">
              <p>
                We may update these Terms of Service from time to time. Changes will be posted 
                on this page with a new "Last Updated" date.
              </p>
            </div>
          </section>

          {/* 7. Contact */}
   
        </div>

        <footer className="terms-footer">
          <p>© {today.getFullYear()} Emerald Appraisal. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default TermsConditions;
